import e from "react";

function t(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}

function r(e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
}

var n = r(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = "function" == typeof Symbol && Symbol.for,
      n = r ? Symbol.for("react.element") : 60103,
      o = r ? Symbol.for("react.portal") : 60106,
      a = r ? Symbol.for("react.fragment") : 60107,
      i = r ? Symbol.for("react.strict_mode") : 60108,
      c = r ? Symbol.for("react.profiler") : 60114,
      u = r ? Symbol.for("react.provider") : 60109,
      s = r ? Symbol.for("react.context") : 60110,
      f = r ? Symbol.for("react.async_mode") : 60111,
      p = r ? Symbol.for("react.concurrent_mode") : 60111,
      l = r ? Symbol.for("react.forward_ref") : 60112,
      y = r ? Symbol.for("react.suspense") : 60113,
      d = r ? Symbol.for("react.memo") : 60115,
      m = r ? Symbol.for("react.lazy") : 60116;

  function v(e) {
    if ("object" == typeof e && null !== e) {
      var t = e.$$typeof;

      switch (t) {
        case n:
          switch (e = e.type) {
            case f:
            case p:
            case a:
            case c:
            case i:
            case y:
              return e;

            default:
              switch (e = e && e.$$typeof) {
                case s:
                case l:
                case u:
                  return e;

                default:
                  return t;
              }

          }

        case m:
        case d:
        case o:
          return t;
      }
    }
  }

  function b(e) {
    return v(e) === p;
  }

  t.typeOf = v, t.AsyncMode = f, t.ConcurrentMode = p, t.ContextConsumer = s, t.ContextProvider = u, t.Element = n, t.ForwardRef = l, t.Fragment = a, t.Lazy = m, t.Memo = d, t.Portal = o, t.Profiler = c, t.StrictMode = i, t.Suspense = y, t.isValidElementType = function (e) {
    return "string" == typeof e || "function" == typeof e || e === a || e === p || e === c || e === i || e === y || "object" == typeof e && null !== e && (e.$$typeof === m || e.$$typeof === d || e.$$typeof === u || e.$$typeof === s || e.$$typeof === l);
  }, t.isAsyncMode = function (e) {
    return b(e) || v(e) === f;
  }, t.isConcurrentMode = b, t.isContextConsumer = function (e) {
    return v(e) === s;
  }, t.isContextProvider = function (e) {
    return v(e) === u;
  }, t.isElement = function (e) {
    return "object" == typeof e && null !== e && e.$$typeof === n;
  }, t.isForwardRef = function (e) {
    return v(e) === l;
  }, t.isFragment = function (e) {
    return v(e) === a;
  }, t.isLazy = function (e) {
    return v(e) === m;
  }, t.isMemo = function (e) {
    return v(e) === d;
  }, t.isPortal = function (e) {
    return v(e) === o;
  }, t.isProfiler = function (e) {
    return v(e) === c;
  }, t.isStrictMode = function (e) {
    return v(e) === i;
  }, t.isSuspense = function (e) {
    return v(e) === y;
  };
});
t(n);
var o = r(function (e, t) {
  "production" !== process.env.NODE_ENV && function () {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var e = "function" == typeof Symbol && Symbol.for,
        r = e ? Symbol.for("react.element") : 60103,
        n = e ? Symbol.for("react.portal") : 60106,
        o = e ? Symbol.for("react.fragment") : 60107,
        a = e ? Symbol.for("react.strict_mode") : 60108,
        i = e ? Symbol.for("react.profiler") : 60114,
        c = e ? Symbol.for("react.provider") : 60109,
        u = e ? Symbol.for("react.context") : 60110,
        s = e ? Symbol.for("react.async_mode") : 60111,
        f = e ? Symbol.for("react.concurrent_mode") : 60111,
        p = e ? Symbol.for("react.forward_ref") : 60112,
        l = e ? Symbol.for("react.suspense") : 60113,
        y = e ? Symbol.for("react.memo") : 60115,
        d = e ? Symbol.for("react.lazy") : 60116;

    function m(e) {
      if ("object" == typeof e && null !== e) {
        var t = e.$$typeof;

        switch (t) {
          case r:
            var m = e.type;

            switch (m) {
              case s:
              case f:
              case o:
              case i:
              case a:
              case l:
                return m;

              default:
                var v = m && m.$$typeof;

                switch (v) {
                  case u:
                  case p:
                  case c:
                    return v;

                  default:
                    return t;
                }

            }

          case d:
          case y:
          case n:
            return t;
        }
      }
    }

    var v = s,
        b = f,
        h = u,
        g = c,
        w = r,
        O = p,
        E = o,
        S = d,
        j = y,
        P = n,
        x = i,
        T = a,
        _ = l,
        N = !1;

    function $(e) {
      return m(e) === f;
    }

    t.typeOf = m, t.AsyncMode = v, t.ConcurrentMode = b, t.ContextConsumer = h, t.ContextProvider = g, t.Element = w, t.ForwardRef = O, t.Fragment = E, t.Lazy = S, t.Memo = j, t.Portal = P, t.Profiler = x, t.StrictMode = T, t.Suspense = _, t.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === o || e === f || e === i || e === a || e === l || "object" == typeof e && null !== e && (e.$$typeof === d || e.$$typeof === y || e.$$typeof === c || e.$$typeof === u || e.$$typeof === p);
    }, t.isAsyncMode = function (e) {
      return N || (N = !0, function (e, t) {
        if (void 0 === t) throw new Error("`lowPriorityWarning(condition, format, ...args)` requires a warning message argument");

        if (!e) {
          for (var r = arguments.length, n = Array(r > 2 ? r - 2 : 0), o = 2; o < r; o++) {
            n[o - 2] = arguments[o];
          }

          (function (e) {
            for (var t = arguments.length, r = Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
              r[n - 1] = arguments[n];
            }

            var o = 0,
                a = "Warning: " + e.replace(/%s/g, function () {
              return r[o++];
            });
            "undefined" != typeof console && console.warn(a);

            try {
              throw new Error(a);
            } catch (e) {}
          }).apply(void 0, [t].concat(n));
        }
      }(!1, "The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), $(e) || m(e) === s;
    }, t.isConcurrentMode = $, t.isContextConsumer = function (e) {
      return m(e) === u;
    }, t.isContextProvider = function (e) {
      return m(e) === c;
    }, t.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === r;
    }, t.isForwardRef = function (e) {
      return m(e) === p;
    }, t.isFragment = function (e) {
      return m(e) === o;
    }, t.isLazy = function (e) {
      return m(e) === d;
    }, t.isMemo = function (e) {
      return m(e) === y;
    }, t.isPortal = function (e) {
      return m(e) === n;
    }, t.isProfiler = function (e) {
      return m(e) === i;
    }, t.isStrictMode = function (e) {
      return m(e) === a;
    }, t.isSuspense = function (e) {
      return m(e) === l;
    };
  }();
});
t(o);

var a = r(function (e) {
  e.exports = "production" === process.env.NODE_ENV ? n : o;
}),
    i = Object.getOwnPropertySymbols,
    c = Object.prototype.hasOwnProperty,
    u = Object.prototype.propertyIsEnumerable,
    s = function () {
  try {
    if (!Object.assign) return !1;
    var e = new String("abc");
    if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

    for (var t = {}, r = 0; r < 10; r++) {
      t["_" + String.fromCharCode(r)] = r;
    }

    if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
      return t[e];
    }).join("")) return !1;
    var n = {};
    return "abcdefghijklmnopqrst".split("").forEach(function (e) {
      n[e] = e;
    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
  } catch (e) {
    return !1;
  }
}() ? Object.assign : function (e, t) {
  for (var r, n, o = function (e) {
    if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(e);
  }(e), a = 1; a < arguments.length; a++) {
    for (var s in r = Object(arguments[a])) {
      c.call(r, s) && (o[s] = r[s]);
    }

    if (i) {
      n = i(r);

      for (var f = 0; f < n.length; f++) {
        u.call(r, n[f]) && (o[n[f]] = r[n[f]]);
      }
    }
  }

  return o;
},
    f = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
    p = function p() {};

if ("production" !== process.env.NODE_ENV) {
  var l = f,
      y = {},
      d = Function.call.bind(Object.prototype.hasOwnProperty);

  p = function p(e) {
    var t = "Warning: " + e;
    "undefined" != typeof console && console.error(t);

    try {
      throw new Error(t);
    } catch (e) {}
  };
}

function m(e, t, r, n, o) {
  if ("production" !== process.env.NODE_ENV) for (var a in e) {
    if (d(e, a)) {
      var i;

      try {
        if ("function" != typeof e[a]) {
          var c = Error((n || "React class") + ": " + r + " type `" + a + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[a] + "`.");
          throw c.name = "Invariant Violation", c;
        }

        i = e[a](t, a, n, r, null, l);
      } catch (e) {
        i = e;
      }

      if (!i || i instanceof Error || p((n || "React class") + ": type specification of " + r + " `" + a + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof i + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), i instanceof Error && !(i.message in y)) {
        y[i.message] = !0;
        var u = o ? o() : "";
        p("Failed " + r + " type: " + i.message + (null != u ? u : ""));
      }
    }
  }
}

m.resetWarningCache = function () {
  "production" !== process.env.NODE_ENV && (y = {});
};

var v = m,
    b = Function.call.bind(Object.prototype.hasOwnProperty),
    h = function h() {};

function g() {
  return null;
}

function w() {}

function O() {}

"production" !== process.env.NODE_ENV && (h = function h(e) {
  var t = "Warning: " + e;
  "undefined" != typeof console && console.error(t);

  try {
    throw new Error(t);
  } catch (e) {}
}), O.resetWarningCache = w;

var E = r(function (e) {
  e.exports = "production" !== process.env.NODE_ENV ? function (e, t) {
    var r = "function" == typeof Symbol && Symbol.iterator,
        n = "@@iterator",
        o = "<<anonymous>>",
        i = {
      array: p("array"),
      bool: p("boolean"),
      func: p("function"),
      number: p("number"),
      object: p("object"),
      string: p("string"),
      symbol: p("symbol"),
      any: u(g),
      arrayOf: function arrayOf(e) {
        return u(function (t, r, n, o, a) {
          if ("function" != typeof e) return new c("Property `" + a + "` of component `" + n + "` has invalid PropType notation inside arrayOf.");
          var i = t[r];
          if (!Array.isArray(i)) return new c("Invalid " + o + " `" + a + "` of type `" + y(i) + "` supplied to `" + n + "`, expected an array.");

          for (var u = 0; u < i.length; u++) {
            var s = e(i, u, n, o, a + "[" + u + "]", f);
            if (s instanceof Error) return s;
          }

          return null;
        });
      },
      element: u(function (t, r, n, o, a) {
        var i = t[r];
        return e(i) ? null : new c("Invalid " + o + " `" + a + "` of type `" + y(i) + "` supplied to `" + n + "`, expected a single ReactElement.");
      }),
      elementType: u(function (e, t, r, n, o) {
        var i = e[t];
        return a.isValidElementType(i) ? null : new c("Invalid " + n + " `" + o + "` of type `" + y(i) + "` supplied to `" + r + "`, expected a single ReactElement type.");
      }),
      instanceOf: function instanceOf(e) {
        return u(function (t, r, n, a, i) {
          var u;
          return t[r] instanceof e ? null : new c("Invalid " + a + " `" + i + "` of type `" + ((u = t[r]).constructor && u.constructor.name ? u.constructor.name : o) + "` supplied to `" + n + "`, expected instance of `" + (e.name || o) + "`.");
        });
      },
      node: u(function (e, t, r, n, o) {
        return l(e[t]) ? null : new c("Invalid " + n + " `" + o + "` supplied to `" + r + "`, expected a ReactNode.");
      }),
      objectOf: function objectOf(e) {
        return u(function (t, r, n, o, a) {
          if ("function" != typeof e) return new c("Property `" + a + "` of component `" + n + "` has invalid PropType notation inside objectOf.");
          var i = t[r],
              u = y(i);
          if ("object" !== u) return new c("Invalid " + o + " `" + a + "` of type `" + u + "` supplied to `" + n + "`, expected an object.");

          for (var s in i) {
            if (b(i, s)) {
              var p = e(i, s, n, o, a + "." + s, f);
              if (p instanceof Error) return p;
            }
          }

          return null;
        });
      },
      oneOf: function oneOf(e) {
        return Array.isArray(e) ? u(function (t, r, n, o, a) {
          for (var i = t[r], u = 0; u < e.length; u++) {
            if ((s = i) === (f = e[u]) ? 0 !== s || 1 / s == 1 / f : s != s && f != f) return null;
          }

          var s,
              f,
              p = JSON.stringify(e, function (e, t) {
            return "symbol" === d(t) ? String(t) : t;
          });
          return new c("Invalid " + o + " `" + a + "` of value `" + String(i) + "` supplied to `" + n + "`, expected one of " + p + ".");
        }) : ("production" !== process.env.NODE_ENV && h(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), g);
      },
      oneOfType: function oneOfType(e) {
        if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && h("Invalid argument supplied to oneOfType, expected an instance of array."), g;

        for (var t = 0; t < e.length; t++) {
          var r = e[t];
          if ("function" != typeof r) return h("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + m(r) + " at index " + t + "."), g;
        }

        return u(function (t, r, n, o, a) {
          for (var i = 0; i < e.length; i++) {
            if (null == (0, e[i])(t, r, n, o, a, f)) return null;
          }

          return new c("Invalid " + o + " `" + a + "` supplied to `" + n + "`.");
        });
      },
      shape: function shape(e) {
        return u(function (t, r, n, o, a) {
          var i = t[r],
              u = y(i);
          if ("object" !== u) return new c("Invalid " + o + " `" + a + "` of type `" + u + "` supplied to `" + n + "`, expected `object`.");

          for (var s in e) {
            var p = e[s];

            if (p) {
              var l = p(i, s, n, o, a + "." + s, f);
              if (l) return l;
            }
          }

          return null;
        });
      },
      exact: function exact(e) {
        return u(function (t, r, n, o, a) {
          var i = t[r],
              u = y(i);
          if ("object" !== u) return new c("Invalid " + o + " `" + a + "` of type `" + u + "` supplied to `" + n + "`, expected `object`.");
          var p = s({}, t[r], e);

          for (var l in p) {
            var d = e[l];
            if (!d) return new c("Invalid " + o + " `" + a + "` key `" + l + "` supplied to `" + n + "`.\nBad object: " + JSON.stringify(t[r], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
            var m = d(i, l, n, o, a + "." + l, f);
            if (m) return m;
          }

          return null;
        });
      }
    };

    function c(e) {
      this.message = e, this.stack = "";
    }

    function u(e) {
      if ("production" !== process.env.NODE_ENV) var r = {},
          n = 0;

      function a(a, i, u, s, p, l, y) {
        if (s = s || o, l = l || u, y !== f) {
          if (t) {
            var d = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            throw d.name = "Invariant Violation", d;
          }

          if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
            var m = s + ":" + u;
            !r[m] && n < 3 && (h("You are manually calling a React.PropTypes validation function for the `" + l + "` prop on `" + s + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), r[m] = !0, n++);
          }
        }

        return null == i[u] ? a ? new c(null === i[u] ? "The " + p + " `" + l + "` is marked as required in `" + s + "`, but its value is `null`." : "The " + p + " `" + l + "` is marked as required in `" + s + "`, but its value is `undefined`.") : null : e(i, u, s, p, l);
      }

      var i = a.bind(null, !1);
      return i.isRequired = a.bind(null, !0), i;
    }

    function p(e) {
      return u(function (t, r, n, o, a, i) {
        var u = t[r];
        return y(u) !== e ? new c("Invalid " + o + " `" + a + "` of type `" + d(u) + "` supplied to `" + n + "`, expected `" + e + "`.") : null;
      });
    }

    function l(t) {
      switch (typeof t) {
        case "number":
        case "string":
        case "undefined":
          return !0;

        case "boolean":
          return !t;

        case "object":
          if (Array.isArray(t)) return t.every(l);
          if (null === t || e(t)) return !0;

          var o = function (e) {
            var o = t && (r && t[r] || t[n]);
            if ("function" == typeof o) return o;
          }();

          if (!o) return !1;
          var a,
              i = o.call(t);

          if (o !== t.entries) {
            for (; !(a = i.next()).done;) {
              if (!l(a.value)) return !1;
            }
          } else for (; !(a = i.next()).done;) {
            var c = a.value;
            if (c && !l(c[1])) return !1;
          }

          return !0;

        default:
          return !1;
      }
    }

    function y(e) {
      var t = typeof e;
      return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, t) {
        return "symbol" === e || !!t && ("Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol);
      }(t, e) ? "symbol" : t;
    }

    function d(e) {
      if (null == e) return "" + e;
      var t = y(e);

      if ("object" === t) {
        if (e instanceof Date) return "date";
        if (e instanceof RegExp) return "regexp";
      }

      return t;
    }

    function m(e) {
      var t = d(e);

      switch (t) {
        case "array":
        case "object":
          return "an " + t;

        case "boolean":
        case "date":
        case "regexp":
          return "a " + t;

        default:
          return t;
      }
    }

    return c.prototype = Error.prototype, i.checkPropTypes = v, i.resetWarningCache = v.resetWarningCache, i.PropTypes = i, i;
  }(a.isElement, !0) : function () {
    function e(e, t, r, n, o, a) {
      if (a !== f) {
        var i = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw i.name = "Invariant Violation", i;
      }
    }

    function t() {
      return e;
    }

    e.isRequired = e;
    var r = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      elementType: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t,
      checkPropTypes: O,
      resetWarningCache: w
    };
    return r.PropTypes = r, r;
  }();
}),
    S = [],
    j = function (t) {
  function r() {
    t.apply(this, arguments), this.state = {
      isLoading: !0
    };
  }

  return t && (r.__proto__ = t), (r.prototype = Object.create(t && t.prototype)).constructor = r, r.prototype.loadTweetForProps = function (e) {
    var t = this,
        r = function r() {
      window.twttr.ready().then(function (r) {
        var n = r.widgets;
        t._div && (t._div.innerHTML = "");
        var o = e.onTweetLoadSuccess,
            a = e.onTweetLoadError;
        n.createTweetEmbed(t.props.id, t._div, e.options).then(function (e) {
          t.setState({
            isLoading: !1
          }), o && o(e);
        }).catch(a);
      });
    },
        n = window.twttr;

    n && n.ready ? r() : function (e, t) {
      if (0 === S.length) {
        S.push(t);
        var r = document.createElement("script");
        r.setAttribute("src", e), r.onload = function () {
          return S.forEach(function (e) {
            return e();
          });
        }, document.body.appendChild(r);
      } else S.push(t);
    }((window.location.protocol.indexOf("file") >= 0 ? this.props.protocol : "") + "//platform.twitter.com/widgets.js", r);
  }, r.prototype.componentDidMount = function () {
    this.loadTweetForProps(this.props);
  }, r.prototype.shouldComponentUpdate = function (e, t) {
    return this.props.id !== e.id || this.props.className !== e.className;
  }, r.prototype.componentWillUpdate = function (e, t) {
    this.props.id !== e.id && this.loadTweetForProps(e);
  }, r.prototype.render = function () {
    var t = this;
    return e.createElement("div", {
      className: this.props.className,
      ref: function ref(e) {
        t._div = e;
      }
    }, this.state.isLoading && this.props.placeholder);
  }, r;
}(e.Component);

j.propTypes = {
  id: E.string,
  options: E.object,
  protocol: E.string,
  onTweetLoadSuccess: E.func,
  onTweetLoadError: E.func,
  className: E.string
}, j.defaultProps = {
  protocol: "https:",
  options: {},
  className: null
};
export default j;